module.exports = __webpack_public_path__ + "img/消防管理.e4738503.svg";